import { instance, instanceWithAuth } from '.'

/** user **/ 
const login = (params) => instance.post('/login', params)
const loginG = (params) => instance.post('/googlelogin', params)
const authsend = () => instanceWithAuth.post('/authsend')

const nft_proc = (params) => instanceWithAuth.post('/nft_proc', params)

const signup = (params) =>
  instance.post('/register', params, { withCredentials: true })
const userInfo = () => instanceWithAuth.post('/user/info')


const verify = (params) => instance.post('/auth/verify', params)
const sendVerifyCode = (params) => instance.post('/auth/send', params)
const withdraw = () => instanceWithAuth.post('/withdraw')
const auth_sms = (params) => instance.post('/apps/auth_sms', params)
const auth_sms_confirm = (params) =>
  instance.post('/apps/auth_sms_confirm', params)
const auth_sms_complete = (params) =>
  instance.post('/apps/auth_sms_complete', params)
const mailcheck = (params) => instance.post('/mailcheck', params)

// push등록 
const register_push = (params) => instanceWithAuth.post('register/push', params)


/** STAFF **/ 
const auth_code = (params) => instance.post('/staff/auth_code', params)  
const staff_act = (params) => instanceWithAuth.post('/staff/staff_act', params)  

/** Market **/ 
const market_act = (params) => instance.post('/market_act', params)  


/** **/ 
// 5. 카드 소지자 정보 요청
const kyc_req = (params) => instanceWithAuth.post('/cards/kycReq', params)  
// ???? 
const kyc_chk = (params) => instanceWithAuth.post('/cards/kycChk', params)  
// 6. 카드 활성화 요청
const card_activa = (params) => instanceWithAuth.post('/cards/activa', params)  
// 7. 카드 정보 확인(
const card_info = (params) => instanceWithAuth.get('/cards/info', params)  
// 8. 카드 충전
const recharge = (params) => instanceWithAuth.post('/cards/recharge', params)  
// 9. 충전 상태 확인 
const recharge_chk = (params) => instanceWithAuth.post('/cards/recharge_chk', params)  
// 10.카드 거래내역 
const tradeHistory = (params) => instanceWithAuth.get('/cards/trade', params)  
// 11.결제 주문 order/create
const card_order = (params) => instanceWithAuth.post('/cards/order', params)   ; 



export {
  auth_code , 
  staff_act , 
  market_act, 
  loginG , 
  authsend , 
  nft_proc , 

  login,
  signup,
  userInfo,
  verify,
  sendVerifyCode,
  withdraw,
  auth_sms,
  auth_sms_confirm,
  auth_sms_complete,
  mailcheck , 
  register_push , 


  
  kyc_req , 
  kyc_chk ,
  card_activa ,
  card_info ,
  recharge,
  recharge_chk,
  tradeHistory,
  card_order,


}
